<template>
  <div>
    <div class="row mb-2">
      <div class="col-md-12 block text-right">
        <h4>
          Status de Sincronização SIGAP:
          <span
            :class="'badge badge-' + (sincronizacao ? 'success' : 'danger')"
            v-if="sincronizacao != null"
            >O{{ sincronizacao ? "n" : "ff" }}line</span
          >
          <span class="badge badge-secondary" v-else>Carregando...</span>
        </h4>
      </div>
    </div>
    <section v-if="section == 1">
      <div class="row">
        <div class="col-12 mb-1">
          Selecione seu Setor
          <v-select
            v-model="setor"
            :options="setores"
            :label="'title'"
            :reduce="(setores) => setores.id"
            class="vselect"
            @input="getLocais()"
          />
        </div>
        <div class="col-12 mb-1" v-if="setor">
          Selecione seu Local
          <v-select
            v-model="local"
            :options="locais"
            :label="'title'"
            :reduce="(locais) => locais.id"
            class="vselect"
            @input="setSetorLocal()"
          />
        </div>
      </div>
    </section>
    <section v-if="section == 2">
      <!-- Indicadores (KPIs) -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="fas fa-chart-line mr-2"></i>Indicadores -
                {{ new Date().toLocaleDateString("pt-BR") }}
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
                  <div class="kpi-card kpi-waiting">
                    <div class="kpi-icon">
                      <i class="fas fa-clock"></i>
                    </div>
                    <div class="kpi-content">
                      <div class="kpi-value">
                        {{ kpis.pacientesAguardando }}
                      </div>
                      <div class="kpi-label">Pacientes Aguardando</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
                  <div class="kpi-card kpi-time">
                    <div class="kpi-icon">
                      <i class="fas fa-hourglass-half"></i>
                    </div>
                    <div class="kpi-content">
                      <div class="kpi-value">
                        {{ kpis.tempoMedioEspera }}min
                      </div>
                      <div class="kpi-label">Tempo Médio Espera (1h)</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
                  <div class="kpi-card kpi-attended">
                    <div class="kpi-icon">
                      <i class="fas fa-user-check"></i>
                    </div>
                    <div class="kpi-content">
                      <div class="kpi-value">{{ kpis.episodiosAtendidos }}</div>
                      <div class="kpi-label">Atendidos Hoje</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
                  <div class="kpi-card kpi-cancelled">
                    <div class="kpi-icon">
                      <i class="fas fa-user-times"></i>
                    </div>
                    <div class="kpi-content">
                      <div class="kpi-value">
                        {{ kpis.episodiosCancelados }}
                      </div>
                      <div class="kpi-label">Cancelados Hoje</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
                  <div class="kpi-card kpi-return">
                    <div class="kpi-icon">
                      <i class="fas fa-redo"></i>
                    </div>
                    <div class="kpi-content">
                      <div class="kpi-value">
                        {{ kpis.episodiosRetorno72h }}
                      </div>
                      <div class="kpi-label">Retornos 72h</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
                  <div class="kpi-card kpi-return-time">
                    <div class="kpi-icon">
                      <i class="fas fa-clock"></i>
                    </div>
                    <div class="kpi-content">
                      <div class="kpi-value">{{ kpis.tempoMedioRetorno }}h</div>
                      <div class="kpi-label">Tempo Médio Retorno</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6">
          <h4>
            {{ me.setor ? me.setor.title + " (" + me.local.title + ")" : "" }}
          </h4>
          <h6 style="line-height: 0">
            Senhas no setor: {{ atendimentos.length }}
          </h6>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <button
            class="btn btn-sm btn-secondary m-0 d-flex justify-content-between align-items-center"
            @click="trocarLocal()"
            style="height: 100%"
          >
            <span class="mr-1">Trocar de setor/local</span>
            <i class="fas fa-sign-out-alt"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card content-crud">
            <div class="ibox-title" style="padding: 16px">
              <h3>
                Fila
                <!-- <router-link
                  v-if="$store.state.user.access_nivel == 6"
                  to="/triage/add"
                  class="btn btn-primary"
                  style="float: right; margin-top: -5px"
                  >Novo Episódio</router-link
                > -->
              </h3>
            </div>

            <div class="col-md-4 mb-1">
              <toggle-button
                @change="atualizarTela"
                :value="autoRefreshAtivado"
                :labels="{ checked: 'Sim', unchecked: 'Não' }"
                :width="55"
              />
              Forçar atualização automatica
            </div>

            <div class="ibox-content">
              <div class="row" style="padding: 0px 0px 16px 16px">
                <div class="col-md-2">
                  <label>Nº do Episódio</label>
                  <input type="text" class="form-control" v-model="filtro.id" />
                </div>
                <div class="col-md-2">
                  <label>Nome do Paciente</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.nome_paciente"
                  />
                </div>
                <div class="col-md-2">
                  <label>Senha</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.senha"
                  />
                </div>
                <div class="col-md-2">
                  <label>Reentrada 72h</label>
                  <select class="form-control" v-model="filtro.retorno72h">
                    <option value="">Todos</option>
                    <option value="SIM">Sim</option>
                    <option value="NÃO">Não</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label>Prioridade</label>
                  <v-select
                    v-model="filtro.priority_id"
                    :options="prioridades"
                    label="title"
                    :reduce="(prioridade) => prioridade.id"
                    placeholder="Todas"
                    :clearable="true"
                    :searchable="true"
                    track-by="uniqueKey"
                    class="v-select form-control-style"
                  />
                </div>
                <div class="col-md-3">
                  <label>Linha de Cuidado</label>
                  <v-select
                    v-model="filtro.care_line_id"
                    :options="care_lines"
                    label="title"
                    :reduce="(care_line) => care_line.id"
                    placeholder="Todas"
                    :clearable="true"
                    :searchable="true"
                    class="v-select form-control-style"
                  />
                </div>
                <div style="margin-top: 25px">
                  <button class="btn btn-primary mr-2" @click="getEntity">
                    Filtrar
                  </button>
                  <button class="btn btn-secondary" @click="limparFiltros()">
                    Limpar
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive-sm">
                    <table
                      role="table"
                      aria-busy="false"
                      aria-colcount="4"
                      class="table b-table"
                    >
                      <thead role="rowgroup" class="">
                        <tr role="row" class="">
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="1"
                            class=""
                          >
                            <div>Episódio</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="1"
                            class=""
                          >
                            <div>Classificação</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="1"
                            class=""
                          >
                            <div>Senha</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="2"
                            class=""
                          >
                            <div>Nome</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="3"
                            class=""
                          >
                            <div>Idade</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            <div>Data/Hora no Setor</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            <div>Tempo de Espera</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            <div>Reentrada 72h</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            <div>Prioridade</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            <div>Linha de Cuidado</div>
                          </th>
                          <th
                            role="columnheader"
                            scope="col"
                            aria-colindex="4"
                            class=""
                          >
                            <div>Ações</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody role="rowgroup">
                        <tr
                          role="row"
                          class=""
                          v-for="atendimento in atendimentos"
                          :key="atendimento.id"
                        >
                          <td aria-colindex="1" role="cell" class="">
                            {{ atendimento.id }}
                          </td>
                          <td aria-colindex="1" role="cell" class="">
                            <div class="row">
                              <div class="col-md-12">
                                <router-link
                                  :to="'triage/flowchart/' + atendimento.id"
                                  tag="button"
                                  :class="
                                    classificacaoColor(
                                      atendimento.classificacao
                                    )
                                  "
                                >
                                  {{
                                    classificacaoLabel(
                                      atendimento.classificacao
                                    )
                                  }}
                                </router-link>
                              </div>
                            </div>

                            <div class="row" v-if="atendimento.operador_id">
                              <div class="col-md-12 centered mt-1">
                                <span class="badge badge-danger blink"
                                  >Em atendimento</span
                                >
                              </div>
                            </div>
                          </td>
                          <td aria-colindex="1" role="cell" class="">
                            {{ atendimento.senha }}
                          </td>
                          <td aria-colindex="2" role="cell" class="">
                            {{
                              !atendimento.paciente.nome_social ||
                              atendimento.paciente.nome_social ===
                                "Não informado"
                                ? atendimento.paciente.nome_paciente
                                : atendimento.paciente.nome_social
                            }}
                            <span
                              class="badge badge-warning"
                              v-if="atendimento.flag_reclassificacao"
                              >RECLASSIFICAÇÃO</span
                            >
                          </td>
                          <td aria-colindex="3" role="cell" class="">
                            {{
                              diffIdade(atendimento.paciente.data_nascimento)
                            }}
                          </td>
                          <td aria-colindex="4" role="cell" class="">
                            {{ atendimento.created_at_f }}
                          </td>
                          <td aria-colindex="4" role="cell" class="">
                            {{ atendimento.tempo_espera_unidade }} min
                          </td>
                          <td aria-colindex="4" role="cell" class="">
                            {{ atendimento.retorno72h }}
                          </td>
                          <td aria-colindex="4" role="cell" class="">
                            {{
                              atendimento.prioridade
                                ? atendimento.prioridade.title
                                : ""
                            }}
                          </td>
                          <td aria-colindex="4" role="cell" class="">
                            {{
                              atendimento.care_line
                                ? atendimento.care_line.title
                                : ""
                            }}
                          </td>
                          <td>
                            <router-link
                              :to="'triage/flowchart/' + atendimento.id"
                              tag="button"
                              class="btn btn-crud info"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Efetuar Atendimento"
                              style="margin-right: 4px"
                            >
                              <i class="fas fa-eye"></i>
                            </router-link>
                            <button
                              class="btn btn-crud edit"
                              alt="Telemedicina"
                              style="margin-right: 5px"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Telemedicina"
                              @click="telemedicina(atendimento)"
                            >
                              <i class="fas fa-tv"></i>
                            </button>
                            <button
                              class="btn btn-crud edit"
                              alt="Chamar no Painel"
                              style="margin-right: 5px"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Chamar no Painel"
                              @click="setOperator(atendimento)"
                              :disabled="getCountdown(atendimento.id)"
                              :class="{
                                'btn-throttle': getCountdown(atendimento.id),
                              }"
                            >
                              <i
                                class="fas fa-volume-up"
                                v-if="!getCountdown(atendimento.id)"
                              ></i>
                              <span
                                v-if="getCountdown(atendimento.id)"
                                class="countdown-number"
                              >
                                {{ getCountdown(atendimento.id) }}
                              </span>
                            </button>
                            <button
                              class="btn btn-crud warning"
                              alt="Marcar como Ausente"
                              style="margin-right: 5px"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Marcar como Ausente"
                              @click="marcarAusente(atendimento)"
                            >
                              <i class="fas fa-user-slash"></i>
                            </button>
                            <button
                              class="btn btn-crud delete"
                              alt="Cancelar Atendimento"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Cancelar Atendimento"
                              @click="cancel(atendimento)"
                            >
                              <i class="fas fa-times"></i>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colspan="11"
                            class="centered mt-2"
                            v-if="atendimentos.length == 0"
                          >
                            Nenhum atendimento na fila de triagem.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
                >
                  <pagination
                    :records="total"
                    :options="options"
                    :per-page="15"
                    @paginate="getEntity"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Modal Cancelamento -->
    <div
      class="modal fade"
      id="modalCancelarCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalCancelarCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalCancelarLongTitle">
              Cancelar Atendimento
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  Você está cancelando um atendimento, após salvar, esta
                  operação não poderá ser desfeita.
                </div>
              </div>
            </div>
            <div class="row mt-1 mb-3">
              <div class="col-md-12">
                <label class="bold" style="font-size: 14px"
                  >Selecione um Motivo</label
                >
                <v-select
                  :options="motivos_cancelamento"
                  :reduce="(motivos) => motivos.id"
                  label="title"
                  v-model="atendimento_modal.motivo_cancelamento_id"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="cancelar"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Ausente -->
    <div
      class="modal fade"
      id="modalAusenteCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAusenteCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAusenteLongTitle">
              Marcar Paciente como Ausente
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-warning" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  Você está marcando este paciente como
                  <strong>AUSENTE</strong>. O paciente será removido da fila
                  principal e adicionado à fila de ausentes.
                </div>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-12">
                <p>
                  <strong>Paciente:</strong>
                  {{
                    atendimento_modal_ausente.paciente
                      ? atendimento_modal_ausente.paciente.nome_paciente
                      : ""
                  }}
                </p>
                <p>
                  <strong>Senha:</strong> {{ atendimento_modal_ausente.senha }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click="confirmarAusente"
              data-dismiss="modal"
            >
              Marcar como Ausente
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Telemedicina -->
    <div
      class="modal fade"
      id="modalTelemedicina"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalTelemedicinaTitulo"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTelemedicinaTitulo">
              <i class="fas fa-tv mr-2"></i>Iniciar Telemedicina
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-info" role="alert">
                  <i class="fas fa-info-circle mr-2"></i>
                  Uma sala de telemedicina será criada e o link será enviado via
                  WhatsApp para o paciente.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="bold" style="font-size: 14px">
                  <i class="fab fa-whatsapp mr-2 text-success"></i>
                  Número do WhatsApp do Paciente
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="modalTelemedicina.telefone"
                  placeholder="Ex: 5511999999999"
                  maxlength="13"
                  @input="formatarTelefone"
                  :class="{
                    'is-invalid':
                      modalTelemedicina.telefone &&
                      !validarTelefone(modalTelemedicina.telefone),
                  }"
                />
                <div
                  v-if="
                    modalTelemedicina.telefone &&
                    !validarTelefone(modalTelemedicina.telefone)
                  "
                  class="invalid-feedback d-block"
                >
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  Formato inválido. Use: 55 + DDD + número (ex: 5511999999999)
                </div>
                <div
                  v-else-if="
                    modalTelemedicina.telefone &&
                    validarTelefone(modalTelemedicina.telefone)
                  "
                  class="valid-feedback d-block"
                >
                  <i class="fas fa-check-circle mr-1"></i>
                  Número válido
                </div>
                <small class="form-text text-muted" v-else>
                  Digite o número com código do país (55) + DDD + número
                </small>
              </div>
            </div>
            <!-- <div class="row mt-3">
              <div class="col-md-12">
                <label class="bold" style="font-size: 14px">
                  <i class="fas fa-comment mr-2"></i>
                  ID da Mensagem (Opcional)
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="modalTelemedicina.mensagemId"
                  placeholder="Ex: itc92801ab-826e-41c0-8f37-edac9edc5c2b"
                />
                <small class="form-text text-muted">
                  Deixe em branco para usar mensagem padrão
                </small>
              </div>
            </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-2"></i>Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="confirmarTelemedicina"
              :disabled="
                !modalTelemedicina.telefone ||
                !validarTelefone(modalTelemedicina.telefone) ||
                enviandoTelemedicina
              "
            >
              <i
                :class="
                  enviandoTelemedicina ? 'fas fa-spinner fa-spin' : 'fas fa-tv'
                "
                class="mr-2"
              ></i>
              {{
                enviandoTelemedicina
                  ? "Criando sala..."
                  : "Criar Sala e Enviar Link"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";

export default {
  data() {
    return {
      me: {},
      section: 1,
      sincronizacao: null,
      atendimentos: [],
      setores: [],
      locais: [],
      setor: null,
      local: null,
      atendimento_modal: {},
      atendimento_modal_ausente: {},
      motivos_cancelamento: [],
      filtro: {},
      prioridades: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      kpis: {
        pacientesAguardando: 0,
        tempoMedioEspera: 0,
        episodiosAtendidos: 0,
        episodiosCancelados: 0,
        episodiosRetorno72h: 0,
        tempoMedioRetorno: 0,
      },
      autoRefreshAtivado: false,
      temporizadorAutoRefresh: null,
      throttleMap: {}, // Unifica controle de throttle e contadores (objeto reativo)
      globalThrottleTimer: null, // Timer único para todos os contadores
      modalTelemedicina: {
        id: null,
        telefone: "",
        mensagemId: "",
      },
      enviandoTelemedicina: false,
      care_lines: [],
    };
  },
  components: { Pagination },
  methods: {
    limparFiltros() {
      this.filtro = {
        id: "",
        nome_paciente: "",
        senha: "",
        retorno72h: "",
        priority_id: null,
        care_line_id: null,
      };

      this.getEntity();
    },
    getPrioridades() {
      const self = this;
      let api = self.$store.state.api + "priorities?paginated=false";

      axios
        .get(api)
        .then((response) => {
          let prioridades = response.data.data || response.data;

          if (prioridades && Array.isArray(prioridades)) {
            const prioridadesUnicas = prioridades
              .filter((p) => p.status === true || p.status === 1)
              .filter(
                (p, index, arr) =>
                  arr.findIndex((item) => item.title === p.title) === index
              )
              .map((p, index) => ({
                id: p.id,
                title: p.title,
                uniqueKey: `${p.title}_${index}`,
              }));

            self.prioridades = prioridadesUnicas;
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar prioridades:", error);
        });
    },
    telemedicina(atendimento) {
      // Preparar dados do modal
      this.modalTelemedicina = {
        id: atendimento.id,
        telefone: "",
        mensagemId: "itc92801ab-826e-41c0-8f37-edac9edc5c2b", // Valor padrão
      };

      // Abrir modal
      $("#modalTelemedicina").modal("show");
    },

    confirmarTelemedicina() {
      const self = this;

      // Validar telefone
      if (!self.modalTelemedicina.telefone) {
        self.$message("Erro", "Número do WhatsApp é obrigatório", "error");
        return;
      }

      // Validar formato básico do telefone
      const telefoneRegex = /^55\d{10,11}$/;
      if (!telefoneRegex.test(self.modalTelemedicina.telefone)) {
        self.$message(
          "Erro",
          "Formato do telefone inválido. Use: 55 + DDD + número",
          "error"
        );
        return;
      }

      self.enviandoTelemedicina = true;
      let api = self.$store.state.api + "atendimento/get-telemedicina";

      const requestData = {
        id: self.modalTelemedicina.id,
        telefone: self.modalTelemedicina.telefone,
        mensagemId:
          self.modalTelemedicina.mensagemId ||
          "itc92801ab-826e-41c0-8f37-edac9edc5c2b",
      };

      axios
        .post(api, requestData)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Sala de telemedicina criada e link enviado via WhatsApp!",
            "success"
          );

          // Abrir a sala de telemedicina em popup
          if (
            response.data &&
            response.data.content &&
            response.data.content.roomUrl
          ) {
            const roomUrl = response.data.content.hostRoomUrl;
            const popup = window.open(
              roomUrl,
              "telemedicina",
              "width=1024,height=768,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,status=no"
            );

            // Verificar se o popup foi bloqueado
            if (!popup) {
              self.$message(
                "Aviso",
                "Popup bloqueado! Clique no link para abrir a sala: " + roomUrl,
                "warning"
              );
            }
          }

          // Fechar modal
          $("#modalTelemedicina").modal("hide");

          // Limpar dados do modal
          self.modalTelemedicina = {
            id: null,
            telefone: "",
            mensagemId: "",
          };
        })
        .catch((error) => {
          self.$message(
            "Erro",
            error.response?.data?.error || "Erro ao criar sala de telemedicina",
            "error"
          );
        })
        .finally(() => {
          self.enviandoTelemedicina = false;
        });
    },

    formatarTelefone() {
      // Remove tudo que não é número
      let telefone = this.modalTelemedicina.telefone.replace(/\D/g, "");

      // Limita a 13 dígitos (55 + 11 dígitos)
      if (telefone.length > 13) {
        telefone = telefone.substring(0, 13);
      }

      this.modalTelemedicina.telefone = telefone;
    },

    validarTelefone(telefone) {
      // Valida formato: 55 + DDD (2 dígitos) + número (8 ou 9 dígitos)
      const telefoneRegex = /^55\d{10,11}$/;
      return telefoneRegex.test(telefone);
    },
    trocarLocal() {
      const self = this;

      self.setor = null;
      self.local = null;

      this.setSetorLocal();
    },
    setSetorLocal() {
      const self = this;
      let api = self.$store.state.api + "user/setar-local";

      axios
        .post(api, { setor: self.setor, local: self.local })
        .then((response) => {
          self.section = 2;
          self.getEntity();
          self.getMe();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    cancelar() {
      const self = this;
      let api = self.$store.state.api + "atendimentos/cancelamento";

      axios
        .post(api, self.atendimento_modal)
        .then((response) => {
          self.$message("Sucesso", "Cancelamento efetuado!", "success");
          self.getEntity();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    atualizarTela(valor) {
      // O toggle-button retorna um objeto, precisamos extrair o value
      const novoValor =
        typeof valor === "object" && valor.value !== undefined
          ? valor.value
          : valor;
      console.log("Toggle changed to:", novoValor);

      this.autoRefreshAtivado = novoValor;

      // Sempre para o timer primeiro
      this.pararTemporizadorAutoRefresh();

      if (novoValor) {
        console.log("Iniciando auto refresh");
        this.iniciarTemporizadorAutoRefresh();
      } else {
        console.log("Parando auto refresh");
      }
    },
    iniciarTemporizadorAutoRefresh() {
      // Primeiro para qualquer timer existente
      this.pararTemporizadorAutoRefresh();

      // Verifica se autoRefreshAtivado é verdadeiro (booleano)
      if (this.autoRefreshAtivado === true) {
        this.temporizadorAutoRefresh = setInterval(() => {
          this.getEntity();
        }, 10000);
      }
    },
    pararTemporizadorAutoRefresh() {
      if (this.temporizadorAutoRefresh) {
        clearInterval(this.temporizadorAutoRefresh);
        this.temporizadorAutoRefresh = null;
      } else {
        console.log("Nenhum timer para parar");
      }
    },
    painel() {
      const self = this;
      let api = self.$store.state.api + "atendimentos/painel";

      axios
        .post(api, self.atendimento_modal_painel)
        .then((response) => {
          self.$message("Sucesso", "Atendimento enviado ao painel!", "success");
          self.getEntity();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    cancel(obj) {
      this.atendimento_modal = obj;
      $("#modalCancelarCenter").modal("show");
    },
    marcarAusente(obj) {
      this.atendimento_modal_ausente = { ...obj };
      this.atendimento_modal_ausente.observacoes_ausente = "";
      $("#modalAusenteCenter").modal("show");
    },
    confirmarAusente() {
      const self = this;
      let api = self.$store.state.api + "atendimentos/marcar-ausente";

      self.$loading(true);

      axios
        .post(api, self.atendimento_modal_ausente)
        .then((response) => {
          self.$message("Sucesso", "Paciente marcado como ausente!", "success");
          self.getEntity();
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    setOperator(atendimento) {
      // Verifica throttle antes de executar
      if (!this.canCallSetOperator(atendimento.id)) {
        return;
      }

      const self = this;
      let api = self.$store.state.api + "atendimento/set-operador";

      // Registra que a chamada foi feita
      this.registerSetOperatorCall(atendimento.id);

      axios
        .post(api, atendimento)
        .then((response) => {
          self.panel(atendimento);
          self.getEntity(self.page, true);
        })
        .catch((error) => {
          swal("Ops!", error.response.data, "error");
          self.getEntity(self.page, true);
          // Remove o throttle em caso de erro
          this.clearSetOperatorThrottle(atendimento.id);
        });
    },

    canCallSetOperator(atendimentoId) {
      const throttleData = this.throttleMap[atendimentoId];
      if (!throttleData) return true;

      const timePassed = Date.now() - throttleData.timestamp;
      if (timePassed < 5000) {
        return false;
      }

      return true;
    },

    registerSetOperatorCall(atendimentoId) {
      // Adiciona ao objeto reativo com timestamp e contador inicial
      this.$set(this.throttleMap, atendimentoId, {
        timestamp: Date.now(),
        remainingSeconds: 5,
      });

      // Inicia timer global se não existir
      this.startGlobalThrottleTimer();
    },

    startGlobalThrottleTimer() {
      if (this.globalThrottleTimer) return;

      this.globalThrottleTimer = setInterval(() => {
        const toRemove = [];

        // Processa todos os throttles de uma vez
        Object.keys(this.throttleMap).forEach((atendimentoId) => {
          const data = this.throttleMap[atendimentoId];
          if (data.remainingSeconds > 1) {
            data.remainingSeconds--;
          } else {
            toRemove.push(atendimentoId);
          }
        });

        // Remove os expirados usando $delete para manter reatividade
        toRemove.forEach((id) => this.$delete(this.throttleMap, id));

        // Para o timer se não há mais throttles
        if (Object.keys(this.throttleMap).length === 0) {
          clearInterval(this.globalThrottleTimer);
          this.globalThrottleTimer = null;
        }
      }, 1000);
    },

    clearSetOperatorThrottle(atendimentoId) {
      this.$delete(this.throttleMap, atendimentoId);
    },

    // Método para contadores (reativo)
    getCountdown(atendimentoId) {
      const throttleData = this.throttleMap[atendimentoId];
      return throttleData ? throttleData.remainingSeconds : null;
    },
    panel(obj) {
      const self = this;
      let api = self.$store.state.api + "chamar-senha";

      axios
        .post(api, obj)
        .then((response) => {
          console.clear();
          console.log(response.data);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });

      // this.atendimento_modal_painel = obj;
      // $("#modalPainelCenter").modal("show");
    },
    classificacaoLabel(classificacao) {
      if (classificacao == 1) {
        return "Vermelho";
      }

      if (classificacao == 2) {
        return "Laranja";
      }

      if (classificacao == 3) {
        return "Amarelo";
      }

      if (classificacao == 4) {
        return "Verde";
      }

      if (classificacao == 5) {
        return "Azul";
      }

      if (classificacao == 6) {
        return "Branco";
      }

      if (classificacao == 998) {
        return "Ausente";
      }

      if (!classificacao) {
        return "Não Classificado";
      }
    },
    classificacaoColor(classificacao) {
      if (classificacao == 1) {
        return "btn-classificacao vermelho";
      }

      if (classificacao == 2) {
        return "btn-classificacao laranja";
      }

      if (classificacao == 3) {
        return "btn-classificacao amarelo";
      }

      if (classificacao == 4) {
        return "btn-classificacao verde";
      }

      if (classificacao == 5) {
        return "btn-classificacao azul";
      }

      if (classificacao == 6) {
        return "btn-classificacao branco";
      }

      if (!classificacao) {
        return "btn-classificacao cinza";
      }

      if (classificacao == 998) {
        return "btn-classificacao vermelho";
      }
    },
    diffIdade(data_nascimento) {
      const self = this;

      var a = moment();
      var b = moment(data_nascimento);

      var years = a.diff(b, "year");
      b.add(years, "years");

      var months = a.diff(b, "months");
      b.add(months, "months");

      var days = a.diff(b, "days");

      if (years < 100) {
        return years + " anos, " + months + " meses, " + days + " dias";
      }
    },
    getEntity: function (page, silence = false) {
      const self = this;

      self.page = page;

      let api =
        self.$store.state.api +
        "get-atendimentos?status=0,4&with[]=prioridade&with[]=care_line&with[]=paciente&page=" +
        self.page;

      if (!silence) {
        self.$loading(true);
      }

      axios
        .post(api, self.filtro)
        .then((response) => {
          self.atendimentos = response.data.data;
          self.total = response.data.total;
          self.$loading(false);
          if (!silence) {
            self.getMe();
            self.getKPIs(); // Atualizar KPIs sempre que atualizar a lista
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getMotivosCancelamento: function (id) {
      const self = this;
      let api = self.$store.state.api + "cancellation_reasons?paginated=false";

      axios
        .get(api, self.atendimento)
        .then((response) => {
          self.motivos_cancelamento = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetores: function () {
      const self = this;
      let api = self.$store.state.api + "setores?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.setores = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCareLines: function () {
      const self = this;
      let api = self.$store.state.api + "care_lines?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.care_lines = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getLocais: function () {
      const self = this;
      let api =
        self.$store.state.api + "locais?paginated=false&setor_id=" + self.setor;

      axios
        .get(api)
        .then((response) => {
          self.locais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMe: function () {
      const self = this;
      let api = self.$store.state.api + "me";

      self.$loading(true);

      axios
        .post(api)
        .then((response) => {
          self.me = response.data;

          if (self.me.local_id == null) {
            self.section = 1;
          } else {
            self.section = 2;
          }

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    search: _.debounce(function (e) {
      this.getEntity();
    }, 800),
    getKPIs: function () {
      const self = this;
      let api = self.$store.state.api + "get-kpis-triagem";

      axios
        .get(api)
        .then((response) => {
          self.kpis = {
            pacientesAguardando: response.data.pacientes_aguardando || 0,
            tempoMedioEspera: Math.round(response.data.tempo_medio_espera || 0),
            episodiosAtendidos: response.data.episodios_atendidos || 0,
            episodiosCancelados: response.data.episodios_cancelados || 0,
            episodiosRetorno72h: response.data.episodios_retorno_72h || 0,
            tempoMedioRetorno: Math.round(
              response.data.tempo_medio_retorno || 0
            ),
          };
        })
        .catch((error) => {
          console.log("Erro ao carregar KPIs:", error);
          // Manter valores padrão em caso de erro
        });
    },
    getStatusSincronizacao: function () {
      const self = this;
      let api = self.$store.state.api + "status-integracao";

      axios
        .get(api, self.atendimento)
        .then((response) => {
          self.sincronizacao = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;

    self.getStatusSincronizacao();
    self.getEntity();
    self.getKPIs();
    self.getSetores();
    self.getPrioridades();
    self.getMotivosCancelamento();
    self.getCareLines();

    // Limpar modal quando fechado
    $("#modalTelemedicina").on("hidden.bs.modal", function () {
      self.modalTelemedicina = {
        id: null,
        telefone: "",
        mensagemId: "",
      };
      self.enviandoTelemedicina = false;
    });

    // Iniciar atualização automática já que autoRefreshAtivado inicia como true
    // self.iniciarTemporizadorAutoRefresh();

    setTimeout(function () {
      window.Echo.private("atendimento_status").listen(
        ".AtendimentoStatus",
        (e) => {
          self.getEntity(0, true);
        }
      );
    }, 500);
  },
  created() {},
  beforeDestroy() {
    this.pararTemporizadorAutoRefresh();
    // Limpa o timer global de throttle
    if (this.globalThrottleTimer) {
      clearInterval(this.globalThrottleTimer);
      this.globalThrottleTimer = null;
    }
    // Limpa o objeto throttleMap
    Object.keys(this.throttleMap).forEach((id) => {
      this.$delete(this.throttleMap, id);
    });
  },
  destroyed() {
    this.pararTemporizadorAutoRefresh();
  },
};
</script>

<style scoped>
.alert-danger {
  color: #721c24 !important;
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
}

.alert-warning {
  color: #856404 !important;
  background-color: #fff3cd !important;
  border-color: #ffeaa7 !important;
}

.alert {
  position: relative !important;
  padding: 0.75rem 1.25rem !important;
  margin-bottom: 1rem !important;
  border: 1px solid transparent !important;
  border-radius: 0.25rem !important;
}

.btn-crud.warning {
  background-color: #f39c12 !important;
  border-color: #f39c12 !important;
  color: white !important;
}

.btn-crud.warning:hover {
  background-color: #e67e22 !important;
  border-color: #e67e22 !important;
}

.blink {
  animation: fadeBlink 2s infinite;
}

.btn-throttle {
  background: linear-gradient(45deg, #ff6b35, #f7931e) !important;
  border-color: #ff6b35 !important;
  color: #fff !important;
  cursor: not-allowed !important;
  position: relative;
  font-weight: bold !important;
  box-shadow: 0 0 10px rgba(255, 107, 53, 0.5) !important;
  animation: throttleGlow 1s ease-in-out infinite alternate;
}

.btn-throttle:hover {
  background: linear-gradient(45deg, #ff6b35, #f7931e) !important;
  border-color: #ff6b35 !important;
}

.countdown-number {
  font-size: 20px !important;
  font-weight: 900 !important;
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.9) !important;
  letter-spacing: 2px !important;
  display: inline-block;
  animation: numberPulse 1s ease-in-out infinite;
}

@keyframes throttleGlow {
  0% {
    box-shadow: 0 0 5px rgba(255, 107, 53, 0.5);
    transform: scale(1);
  }
  100% {
    box-shadow: 0 0 20px rgba(255, 107, 53, 0.8),
      0 0 30px rgba(255, 107, 53, 0.4);
    transform: scale(1.05);
  }
}

@keyframes numberPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes fadeBlink {
  0%,
  100% {
    opacity: 1;
  }
  /* totalmente visível */
  50% {
    opacity: 0;
  }
  /* totalmente invisível */
}

/* Estilos para o modal de telemedicina */
.valid-feedback {
  color: #28a745 !important;
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.invalid-feedback {
  color: #dc3545 !important;
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.is-invalid {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.is-valid {
  border-color: #28a745 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
}

.v-select .vs__dropdown-toggle {
  padding: 0.438rem 1rem !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #d8d6de !important;
  border-radius: 0.357rem !important;
  min-height: calc(
    1.5em + 0.876rem + 2px
  ) !important; /* Mesma altura do form-control */
}

/* ✅ Ajustes internos */
.v-select .vs__selected,
.v-select .vs__search {
  margin: 0 !important;
  padding: 0 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
}

.v-select .vs__search {
  background: transparent !important;
  border: none !important;
  outline: none !important;
}

/* ✅ Focus state */
.v-select.vs--open .vs__dropdown-toggle,
.v-select .vs__dropdown-toggle:focus-within {
  border-color: #80bdff !important;
  outline: 0 !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

/* Estilos para KPIs */
.kpi-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  min-height: 90px;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.kpi-icon {
  font-size: 2.5rem;
  margin-right: 15px;
  opacity: 0.8;
}

.kpi-content {
  flex: 1;
}

.kpi-value {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 5px;
}

.kpi-label {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

/* Cores específicas para cada KPI */
.kpi-waiting {
  border-left-color: #f39c12;
}

.kpi-waiting .kpi-icon {
  color: #f39c12;
}

.kpi-waiting .kpi-value {
  color: #f39c12;
}

.kpi-time {
  border-left-color: #3498db;
}

.kpi-time .kpi-icon {
  color: #3498db;
}

.kpi-time .kpi-value {
  color: #3498db;
}

.kpi-attended {
  border-left-color: #27ae60;
}

.kpi-attended .kpi-icon {
  color: #27ae60;
}

.kpi-attended .kpi-value {
  color: #27ae60;
}

.kpi-cancelled {
  border-left-color: #e74c3c;
}

.kpi-cancelled .kpi-icon {
  color: #e74c3c;
}

.kpi-cancelled .kpi-value {
  color: #e74c3c;
}

.kpi-return {
  border-left-color: #9b59b6;
}

.kpi-return .kpi-icon {
  color: #9b59b6;
}

.kpi-return .kpi-value {
  color: #9b59b6;
}

.kpi-return-time {
  border-left-color: #34495e;
}

.kpi-return-time .kpi-icon {
  color: #34495e;
}

.kpi-return-time .kpi-value {
  color: #34495e;
}

@media (max-width: 768px) {
  .kpi-card {
    padding: 15px;
    min-height: 70px;
  }

  .kpi-icon {
    font-size: 2rem;
    margin-right: 10px;
  }

  .kpi-value {
    font-size: 1.5rem;
  }

  .kpi-label {
    font-size: 0.8rem;
  }
}

/* Diminuir fonte dos headers da tabela */
.table-responsive-sm table thead th {
  font-size: 0.85rem !important;
  padding: 8px 5px !important;
  white-space: nowrap;
  text-align: center !important;
  vertical-align: middle !important;
}

.table-responsive-sm table thead th div {
  font-size: 0.85rem !important;
  text-align: center !important;
}

/* Permitir quebra de linha em colunas específicas */
.table-responsive-sm table thead th:nth-child(6) div,
.table-responsive-sm table thead th:nth-child(7) div,
.table-responsive-sm table thead th:nth-child(8) div,
.table-responsive-sm table thead th:nth-child(10) div {
  white-space: normal !important;
  line-height: 1.2 !important;
}

.table-responsive-sm table thead th:nth-child(6),
.table-responsive-sm table thead th:nth-child(7),
.table-responsive-sm table thead th:nth-child(8),
.table-responsive-sm table thead th:nth-child(10) {
  white-space: normal !important;
}

.table-responsive-sm table thead th:nth-child(8),
.table-responsive-sm table tbody td:nth-child(8) {
  width: 110px;
  max-width: 110px;
  text-align: center;
}

/* Compactar colunas da tabela */
.table-responsive-sm table tbody td:nth-child(2) {
  padding: 8px 0px !important;
}

.table-responsive-sm table tbody td:nth-child(2) .row {
  margin: 0 !important;
}

.table-responsive-sm table tbody td:nth-child(2) .col-md-12 {
  padding: 0 !important;
}

.table-responsive-sm table tbody td:nth-child(2) button {
  font-size: 0.75rem !important;
  padding: 10px 6px !important;
  width: 100%;
  white-space: nowrap;
}

.table-responsive-sm table tbody td:nth-child(2) .badge {
  font-size: 0.8rem !important;
}

.table-responsive-sm table tbody td:nth-child(3) {
  font-size: 1rem;
}

.table-responsive-sm table thead th:nth-child(2),
.table-responsive-sm table tbody td:nth-child(2) {
  width: 170px;
  max-width: 170px;
}

.table-responsive-sm table thead th:nth-child(3),
.table-responsive-sm table tbody td:nth-child(3) {
  width: 120px;
  max-width: 120px;
  text-align: center;
}
</style>
